import { Component, OnInit } from '@angular/core';
import { Router, RouterStateSnapshot } from '@angular/router';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-p404',
  templateUrl: './p404.component.html',
  styleUrls: ['./p404.component.css']
})
export class P404Component implements OnInit {
  url: string;
  constructor(private router: Router) {
    this.url = this.router.url;
    if (this.url) {
      const qrcode = this.url.split('/')[1];
      if (qrcode.toLocaleUpperCase().includes("PA0UID0")) {
        this.router.navigateByUrl('/jk');
      } else if (qrcode.toLocaleUpperCase().includes("HI0UID0")) {
        this.router.navigateByUrl('/hi');
      }
    }
  }

  ngOnInit() {

  }
}
